import styled from '@emotion/styled';
import tw from 'twin.macro';

export const Wrapper = styled.div`
  ${tw`bg-white max-w-[1200px] min-w-[860px] m-auto pl-12 relative pt-16`};
`;

export const ContentWrapper = styled.div`
  ${tw`pr-96`}

  h1 {
    ${tw`text-[26px] font-bold mb-6`}
  }
`;

export const RichTextElementWrapper = styled.div`
  ${tw`font-normal leading-normal text-base`}

  .table-responsive {
    ${tw`break-all`}

    table {
      ${tw`min-w-[50%] mt-3 mb-8`}
      ${tw`border border-solid border-grey border-collapse`}
    }

    tr:first-of-type {
      ${tw`text-center bg-grey-light`}
    }

    th,
    tr,
    td {
      ${tw`border border-solid border-grey border-collapse`}
      ${tw`py-[5px] px-[10px]`};
      ${tw`break-words`};
      ${tw`max-w-[800px]`};
    }

    * {
      ${tw`max-w-[800px]`};
    }
  }

  h2,
  h3,
  h4 {
    ${tw`font-bold`}
  }

  h2 {
    ${tw`text-xl`}
  }
  h3 {
    ${tw`text-lg mb-4`}
  }
  h4 {
    ${tw`text-base`}
  }

  p {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    ${tw`mb-6`}

    &:not(:first-of-type) {
      ${tw`mt-4`}
    }

    &:first-of-type {
      ${tw`mt-[3px]`}
    }

    & + figure {
      ${tw`mt-8`}
    }

    & + pre {
      ${tw`-mt-4`}
    }
  }

  img {
    ${tw`max-w-full max-h-full`}
  }

  ol,
  ul {
    ${tw`mb-10 pl-10`}
  }

  ul {
    ${tw`list-disc`}
  }

  ol {
    ${tw`list-decimal`}
  }

  li {
    ${tw`mb-4`}
  }

  a {
    ${tw`text-link no-underline`}

    &:not(.external-link) {
      ${tw`border-b border-solid border-link-lighter`}
      ${tw`hover:text-link-light`}
    }

    &.external-link {
      span,
      strong,
      em {
        ${tw`border-b border-solid border-link-lighter`}
        ${tw`hover:text-link-light`}
      }

      svg {
        ${tw`text-muted mb-1`}
      }
    }
  }

  pre {
    ${tw`mb-7 p-5`}
    ${tw`leading-8 break-words whitespace-pre-wrap`}
    ${tw`bg-grey-bluish`}
    ${tw`border border-solid border-grey rounded-[2px]`}
  }

  code {
    ${tw`text-xxs`}
    ${tw`font-family[monospace]`}
  }

  p,
  li,
  table {
    code {
      ${tw`bg-grey-light rounded-[3px]`}
      ${tw`m-0 px-[5px] py-[2.5px]`}
    }
  }

  blockquote {
    ${tw`border-l-4 border-[#e4e4e4] border-solid leading-normal`}
    ${tw`mx-0 my-[20px] px-[15] py-0`}
  }

  figure {
    ${tw`m-0`}

    & + figure {
      ${tw`mt-8`}
    }

    &:not(:last-of-type) {
      ${tw`mb-8`}
    }
  }
`;
